import React, { Component } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import {
  ResponsiveContainer,
  BarChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Bar,
  Cell
} from 'recharts';

import KarteStore from '../../store';
import { SheetFormat } from '../../types';

type Props = {
  karteStore: KarteStore;
  karteIndex: number;
};

@observer
class BarChartForKarte extends Component<Props> {
  render() {
    const { karteStore, karteIndex } = this.props;
    const sheetFormat = karteStore.sheetFormat;
    const { city, cityDataType, data } = this.props.karteStore.getCityData(
      karteIndex
    );
    if (!data || !cityDataType) return null;

    return (
      <Wrapper>
        <ChartTitle>
          <span
            style={{
              fontWeight: sheetFormat === SheetFormat.Template ? 900 : 100
            }}
          >
            {city}
          </span>
          の{cityDataType}
        </ChartTitle>
        <ChartWrapper>
          <ResponsiveContainer width="96%" height="96%">
            <BarChart
              width={900}
              height={260}
              data={data}
              margin={{ top: 5, right: 0, left: 0, bottom: 25 }}
            >
              <XAxis dataKey="city" />
              <YAxis />
              <Tooltip />
              <CartesianGrid vertical={false} stroke="#eee" />
              <Bar dataKey={cityDataType}>
                {data.map((entry, index) => (
                  <Cell
                    fill={data[index].city === city ? '#4a90e2' : '#ededed'}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </ChartWrapper>
      </Wrapper>
    );
  }

  randomColor(): string {
    let r = (50 + Math.floor(Math.random() * 150)).toString(16).slice(-2);
    let g = (50 + Math.floor(Math.random() * 150)).toString(16).slice(-2);
    let b = (50 + Math.floor(Math.random() * 150)).toString(16).slice(-2);
    let color = '#' + r + g + b;
    return color;
  }
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
  background: white;
  display: flex;
  flex-direction: column;
`;

const ChartTitle = styled.div`
  text-align: center;
  font-size: 18px;
  margin: 10px 0 10px 50px;
`;

const ChartWrapper = styled.div`
  width: 100%;
  flex: 1;
`;

export default BarChartForKarte;
